import { Category, FaceLandmarker, FaceLandmarkerOptions, FilesetResolver } from "@mediapipe/tasks-vision";
import { Euler, Matrix4 } from "three";
import { smoothenVal } from "./utils/smoothValue";


const options: FaceLandmarkerOptions = {
  baseOptions: {
    modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
    delegate: "GPU"
  },
  numFaces: 1,
  runningMode: "VIDEO",
  outputFaceBlendshapes: true,
  outputFacialTransformationMatrixes: true,
};

export class MediaPipePredictor{
  blendshapes: any[] = [];
  rotation: Euler = new Euler();

  _video?: HTMLVideoElement;
  _faceLandmarker?: FaceLandmarker;

  _fps = 30;
  _rate = 33;

  _lastVideoTime = -1;

  _setUpCalled = false;
  _ready = false;
  _run = false;

  constructor(){};

  get ready(){
    return this._ready
  }
  get running(){
    return this._run;
  }

  setMaxFps(fps : number){
    this._fps = Math.max(0, fps)
    this._rate = this._fps ? Math.floor(1000/this._fps) : 0 ;
  }

  async setup(video: HTMLVideoElement){
    if(this._setUpCalled) return;
    this._setUpCalled = true;
    const filesetResolver = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm");
    this._faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, options);

    navigator.mediaDevices.getUserMedia({
      video: { width: 1280, height: 720 },
      audio: false,
    }).then((stream) => {
      video.srcObject = stream;
      video.addEventListener("playing", () => {
        this._ready = true
      }, true);
      video.play();
    });
    this._video = video;
  }

  run(){
    if(!this._run){
      this._run = true
      this._predict();
    } 
  }

  stop(){
    this._run = false;
  }

  _predict = () => {
    if(!this._ready || !this._video || !this._faceLandmarker || !this._run) {
      if(this._run) setTimeout(this._predict, this._rate)
      return;
    }
    let now = Date.now();
    if (this._lastVideoTime !== this._video!.currentTime) {
      this._lastVideoTime = this._video!.currentTime;
      const faceLandmarkerResult = this._faceLandmarker!.detectForVideo(this._video!, now);

      if (faceLandmarkerResult.faceBlendshapes && faceLandmarkerResult.faceBlendshapes.length > 0 && faceLandmarkerResult.faceBlendshapes[0].categories) {
        const newShapes = faceLandmarkerResult.faceBlendshapes[0].categories;
        if(!this.blendshapes.length) this.blendshapes = newShapes;
        else this.blendshapes = newShapes.map((val: Category, i: number) => {
          // val.score = smoothenVal(this.blendshapes[i].score, val.score, 0.9, 0.09)
          return val;
        });
        const matrix = new Matrix4().fromArray(faceLandmarkerResult.facialTransformationMatrixes![0].data);
        this.rotation.setFromRotationMatrix(matrix)
      }
    }
    setTimeout(this._predict, this._rate)
  }
}